import { v4 as uuidv4 } from "uuid";
import { FieldProps } from "../../utils/functionsInterfaces";
import { displayInfo } from "../../utils/messageToast";

export const handleAddFieldAttachments = (
  groupId: string,
  expandedGroups: string[],
  form: any,
  setForm: React.Dispatch<React.SetStateAction<any[]>>,
  setButtonSave: React.Dispatch<React.SetStateAction<boolean>>
) => {
  let newForm = [...form];

  const newField: FieldProps = {
    uuid: uuidv4(),
    id: "",
    name: "",
    isRequired: false,
    isKey: false,
    isNew: true,
    type: "field",
    attribute: "",
    settings: {
      sizeLimit: { max: 10, enabled: true },
      allowedTypes: [
        "doc",
        "docx",
        "png",
        "jpg",
        "jpeg",
        "pdf",
        "xlsx",
        "xls",
        "eml",
        "msg",
        "txt",
        "xml",
        "xlt",
      ],
    },
    fieldType: "multiple_files",
  };

  // Função recursiva para encontrar e adicionar o campo ao grupo correto
  const addFieldToGroup = (groups: any[], groupId: string): boolean => {
    for (let i = 0; i < groups.length; i++) {
      const group = groups[i];

      if (group.uuid === groupId) {
        expandedGroups.push(group.id);

        if ("children" in group) {
          group.children.push(newField);
          newForm = [...form];
        } else {
          group.children = [newField];
          newForm = [...form];
        }
        return true;
      }

      if (group.children) {
        const found = addFieldToGroup(group.children, groupId);
        if (found) return true;
      }
    }
    return false;
  };

  const groupFound = addFieldToGroup([...form], groupId);

  if (groupFound) {
    setForm(newForm);
    setButtonSave(true);
    displayInfo("Campo de anexo criado!");
  } else {
    console.error(`Group with id ${groupId} not found`);
    return;
  }
};
